import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { USER_REQUESTS_TABS, STATUS_TYPES, STATUS_ACTION_TYPES } from '../../values/user-requests.values';
import { USER_REQUESTS_ROUTES } from '../../user-requests.router';
import EdDenyUserRequestComponent from '../../components/ed-deny-user-request/ed-deny-user-request.component.vue';

@Component({
  name: 'ed-list-user-requests',
  components: {
    EdDenyUserRequestComponent
  }
})
export default class EdListUserRequestsComponent extends Vue {

  /* Props */
  @Prop() readonly tab: string;

  @Ref('dataTable') readonly dataTable: any;
  
  /* Data */
  public search: string = ''
  public loading: boolean = true
  public showPaginator: boolean = true;
  public usersSelected: any = []
  public pendingPagination: object = { current: 1, total: 0 }
  public approvedPagination: object = { current: 1, total: 0 }
  public deniedPagination: object = { current: 1, total: 0 }
  public tabs = USER_REQUESTS_TABS
  private ROWS_PER_PAGE: number = 10; 
  private EMPTY_STRING: string = '';

  
  /* Computed */
  get  headers() { 
    let headers = [
      { text:  this.$t('userRequests.headers.username'), align: 'start', value: 'username', sortable: false, show: true },
      { text: this.$t('userRequests.headers.fullName'), value: 'fullName', sortable: false, show: true },
      { text: this.$t('userRequests.headers.email'), value: 'email', sortable: false, show: true },
      { text: this.$t('userRequests.headers.phone'), value: 'phone', sortable: false, show: true },
      { text: this.$t('userRequests.headers.organization'), value: 'organization', sortable: false,  show: true },
      { text: this.$t('userRequests.headers.role'), value: 'role', sortable: false, show: true },
      { text: this.$t('userRequests.headers.actions'), value: 'actions', sortable: false, show: this.tab == this.tabs.USER_REQUESTS }
    ].filter(el => el.show)
    return headers
  }

  get pendingUsers() {
    return this.$store.state.UserRequestsStore.pendingUsers;
  }

  get approvedUsers() {
    return this.$store.state.UserRequestsStore.approvedUsers;
  }

  get deniedUsers() {
    return this.$store.state.UserRequestsStore.rejectedUsers;
  }

  get tableItems() {
    let data;
    switch(this.tab) {
      case this.tabs.USER_REQUESTS:
        data = this.getPendingUsers;
        break;
      case this.tabs.APPROVED_HISTORY:
        data = this.getApprovedUsers;
        break;
      case this.tabs.DENIED_HISTORY:
        data = this.getDeniedUsers;
        break;
      default:
        data = this.getPendingUsers;
    }
    return data
  }

  get getPendingUsers() {
    this.loading = true;
    
     // Check with store if the page was loaded previously    
    let pendingUsers = this.pendingUsers?.find(el => el.page === this.pendingPagination['current']-1)?.content;

    // Fetch new page
    if (!pendingUsers) {
      this.$UserRequests.Store.getUserRequests({
        status: STATUS_TYPES.PENDING, 
        page: this.pendingPagination['current']-1, 
        pageSize: this.ROWS_PER_PAGE
      }).then((res) => { 
        this.pendingPagination['total'] = res.totalPages;
        this.loading = false;
        return res.content;
      }).catch(() => {
        this.loading = false;
      })
    } else this.loading = false;
    return pendingUsers
  }

  get getApprovedUsers() {
    this.loading = true;
    
     // Check with store if the page was loaded previously    
    let approvedUsers = this.approvedUsers?.find(el => el.page === this.approvedPagination['current']-1)?.content;

    // Fetch new page
    if (!approvedUsers) {
      this.$UserRequests.Store.getUserRequests({
        status: STATUS_TYPES.APPROVED, 
        page: this.approvedPagination['current']-1, 
        pageSize: this.ROWS_PER_PAGE
      }).then((res) => { 
        this.approvedPagination['total'] = res.totalPages;
        this.loading = false;
        return res.content;
      }).catch(() => {
        this.loading = false;
      })
    } else this.loading = false;
    return approvedUsers
  }

  get getDeniedUsers() {
    this.loading = true;
    
     // Check with store if the page was loaded previously    
    let deniedUsers = this.deniedUsers?.find(el => el.page === this.deniedPagination['current']-1)?.content;

    // Fetch new page
    if (!deniedUsers) {
      this.$UserRequests.Store.getUserRequests({
        status: STATUS_TYPES.REJECTED, 
        page: this.deniedPagination['current']-1, 
        pageSize: this.ROWS_PER_PAGE
      }).then((res) => { 
        this.deniedPagination['total'] = res.totalPages;
        this.loading = false;
        return res.content;
      }).catch(() => {
        this.loading = false;
      })
    } else this.loading = false;
    return deniedUsers
  }

  get paginationObject(): any {
    if (this.tab === this.tabs.USER_REQUESTS) {
      return this.pendingPagination;

    } else if (this.tab === this.tabs.APPROVED_HISTORY) {
      return this.approvedPagination;

    } else if (this.tab === this.tabs.DENIED_HISTORY) {
      return this.deniedPagination;
    }
  }

  get paginationPage(): number {
    return this.paginationObject['current'];
  }

  get paginationLength(): number {
    return this.paginationObject['total'];
  }

  get dataTableCustomStyle(): string {
    return 'border-radius: inherit;';
  }

  /* Methods */
  private _loadUserRequestInDataTable(): void {
    if (!this.dataTable || !this.dataTable.loadData) {
      return;
    }

    if (!this.tableItems || this.tableItems.length == 0) {
      this.dataTable.loadData({ items: [], headers: this.headers });
      return;
    }
    
    const slots = {
      'item.username' : {
        template: document.querySelector('#item\\.username').innerHTML,
        templateParams: [{
          key: 'item.username',
          value: (params) => params.item.person.userId
        }],
        events: [
          { target: '.usernameRequest', handler: (params) => params.parent.goToUserRequestDetails(params.item) } 
        ]
      },
     'item.fullName' : {
        template: document.querySelector('#item\\.fullName').innerHTML,
        templateParams: [{
          key: 'item.fullName',
          value: (params) => params.item.person.fullName,
        }],
        events: [
          { target: '.fullNameRequest', handler: (params) => params.parent.goToUserRequestDetails(params.item) } 
        ]
      },
      'item.email' : {
        template: document.querySelector('#item\\.email').innerHTML,
        templateParams: [{
          key: 'item.email',
          value: (params) => params.item.person.email,
        }],
        events: [
          { target: '.emailRequest', handler: (params) => params.parent.goToUserRequestDetails(params.item) } 
        ]
      },
      'item.phone' : {
        template: document.querySelector('#item\\.phone').innerHTML,
        templateParams: [{
          key: 'item.phone',
          value: (params) => params.parent.getPhoneNumber(params.item),
        }],
        events: [
          { target: '.phoneRequest', handler: (params) => params.parent.goToUserRequestDetails(params.item) } 
        ]
      },
      'item.organization' : {
        template: document.querySelector('#item\\.organization').innerHTML,
        templateParams: [{
          key: 'item.organization',
          value: (params) => params.item.organization ? params.item.organization.name : this.EMPTY_STRING,
        }],
        events: [
          { target: '.organizationRequest', handler: (params) => params.parent.goToUserRequestDetails(params.item) } 
        ]
      },
      'item.role' : {
        template: document.querySelector('#item\\.role').innerHTML,
        templateParams: [{
          key: 'item.role',
          value: (params) => params.parent.translateAndConvert(params.item.role),
        }],
        events: [
          { target: '.roleRequest', handler: (params) => params.parent.goToUserRequestDetails(params.item) } 
        ]
      },
      'item.actions': {
        template: document.querySelector('#item\\.actions').innerHTML,
        templateParams: [{
        }],
        events: [
          { target: '.approveUser', handler: (params) =>  params.parent.approveUser(params.item) },
          { target: '.denyUser', handler: (params) =>  params.parent.denyUser(params.item) },
        ]
      },
      parent: this,
    };

    this.dataTable.loadData({
      items: this.tableItems,
      headers: this.headers,
      totalItems: this.tableItems.length,
      slots: slots,
    });
  }


  getPhoneNumber(item) {
    let phone = this.EMPTY_STRING;
    if (item.organization && item.organization.phones.length > 0) phone = item.organization.phones[0].phone;
    else if (item.person.phones.length > 0) phone = item.person.phones[0].phone;
    return phone
  }

  denyUser (item: any) {
    this.$EdModal.createModal(EdDenyUserRequestComponent, { userIds: [item.id] });
  }

  denySelected() {
    let userIds = this.usersSelected.map(el => el.id);
    this.$EdModal.createModal(EdDenyUserRequestComponent, { userIds, onDenyActionCallback: this.clearSelectedItems });
  }

  private clearSelectedItems(): void {
    if (this.usersSelected?.length > 0) {
      this.usersSelected = [];
      this.dataTable?.clearSelectedItems();
    }
  }

  approveUser (item: any) {
    this.$EdModal.createConfirmationModal(
      {
        body: this.$t('userRequests.info.approveUserConfirm'), 
        action: async () => {
          await this.doApproveUser([item.id]);
        }
      }
    );
  }

  approveSelected() {
    let userIds = this.usersSelected.map(el => el.id);
    this.$EdModal.createConfirmationModal(
      {
        body: this.$t('userRequests.info.approveUsersSelectedConfirm'), 
        action: async () => {
          await this.doApproveUser(userIds)
        }
      }
    );
  }

  async doApproveUser(requestIds) {
    try { 
      await this.$UserRequests.Services.respondUserRequest({
        requestId: requestIds, 
        action: STATUS_ACTION_TYPES.APPROVE, 
        rejectionNote: this.EMPTY_STRING
      })
      this.$EdToast.create({ 
        msg: `${this.$t('userRequests.success.userApproved')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.$UserRequests.Store.resetUserRequests();
      this.clearSelectedItems();
    } catch {
      this.$EdToast.create({ 
        msg: `${this.$t('userRequests.success.userNoApproved')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }
  }

  translateAndConvert(word) {
    let lowerWord = word.toLowerCase();
    return this.$t(`tools.staff.status.${lowerWord}`)
  }

  goToUserRequestDetails(item) {
    this.$router.push({name: USER_REQUESTS_ROUTES.USER_REQUEST_DETAILS.NAME, query: { requestId: item.id } });
  }

  destroyed() {
    this.$UserRequests.Store.resetUserRequests();
  }

  public onPageUpdate(customEvent: CustomEvent): void {
    const detail: { page: number } = customEvent.detail;
    this.paginationObject['current'] = detail.page;
    this._loadUserRequestInDataTable();
  }

  public onSelecteUpdate(customEvent: CustomEvent): void {
    const detail: { selectedItems: any } = customEvent.detail;
    this.usersSelected = detail.selectedItems;
  }

  @Watch('tableItems', { immediate: true, deep: true })
  private _watchTableItems(): void {
    this.$nextTick(() => {
      setTimeout(() => {
        this._loadUserRequestInDataTable();
      }); 
    });
  }
  
  @Watch('paginationLength', { deep: true, immediate: true })
  private _watchPaginationLength(): void {
    // Refresh the pagination component from initial state
    if (this.paginationLength === 0) {
      this.showPaginator = false;
      this.$nextTick(() => {
        this.showPaginator = true;
      });
    }
  }

  @Watch('$i18n.locale', { deep: true, immediate: true })
  private _watchLanguage(): void {
    this.$nextTick(() => {
      this._loadUserRequestInDataTable();
    });
  }
}